module.exports = __webpack_public_path__ + "fonts/Roboto-LightItalic.129c5057.ttf";